module.exports = __webpack_public_path__ + "static/index/img/baikal-610.cacaeb9f.jpg";